import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ddw-admin-page-card-item',
  templateUrl: './admin-page-card-item.component.html',
  styleUrls: ['./admin-page-card-item.component.css']
})
export class AdminPageCardItemComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
